export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  users: {
    all: ['users'] as const,
    detail: (id: string) => ['users', id] as const,
  },
  roles: {
    all: ['roles'] as const,
  },
  shows: {
    all: ['shows'] as const,
    detail: (id: string) => ['shows', id] as const,
    episodes: (showId: string) => ['shows', showId, 'episodes'] as const,
  },
  equipment: {
    all: ['equipment'] as const,
    detail: (id: string) => ['equipment', id] as const,
    availability: ['equipment', 'availability'] as const,
  },
  episodes: {
    detail: (id: string) => ['episodes', id] as const,
    crew: (episodeId: string) => ['episodes', episodeId, 'crew'] as const,
    activity: (episodeId: string) => ['episodes', episodeId, 'activity'] as const,
    attachments: (episodeId: string) => ['episodes', episodeId, 'attachments'] as const,
  },
  workflows: {
    all: ['workflows'] as const,
    detail: (id: string) => ['workflows', id] as const,
    steps: (id: string) => ['workflows', id, 'steps'] as const,
  },
  tasks: {
    // Invalidate `all` after a step action: the worker's list and the open task
    // detail are two views of the same step, and only refreshing the list left
    // the detail page showing the pre-action buttons.
    all: ['tasks'] as const,
    my: ['tasks', 'my'] as const,
    myAll: ['tasks', 'my', 'all'] as const,
    detail: (stepId: string) => ['tasks', 'detail', stepId] as const,
    episode: (episodeId: string) => ['tasks', 'episode', episodeId] as const,
  },
  push: {
    // Deliberately outside the notifications prefix: that prefix is invalidated
    // on every incoming notification, and the VAPID key is a constant that must
    // keep its staleTime: Infinity instead of refetching on each one.
    vapidPublicKey: ['push', 'vapid-public-key'] as const,
    // The current account's stored endpoint; cleared with the rest of the
    // query cache on logout, so it never answers for the previous user.
    subscription: ['push', 'subscription'] as const,
  },
  notifications: {
    // Prefix for invalidation; every page below lives under it.
    all: ['notifications'] as const,
    // The page is part of the key, or page 2 would overwrite page 1 in the
    // cache and the list would flip back and forth between them.
    list: (page: number) => ['notifications', 'list', page] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
    rules: ['notifications', 'rules'] as const,
    templates: ['notifications', 'templates'] as const,
  },
  reports: {
    episodeStatus: (params?: Record<string, string>) =>
      ['reports', 'episode-status', params] as const,
    teamPerformance: (params?: Record<string, string>) =>
      ['reports', 'team-performance', params] as const,
    phaseDuration: (params?: Record<string, string>) =>
      ['reports', 'phase-duration', params] as const,
  },
  planner: {
    all: ['planner'] as const,
    data: (params?: Record<string, string>) => ['planner', params] as const,
  },
  events: {
    all: ['events'] as const,
    list: (params?: Record<string, string | undefined>) => ['events', 'list', params] as const,
    detail: (id: string) => ['events', 'detail', id] as const,
    occupancy: (date: string, excludeEventId?: string) =>
      ['events', 'occupancy', date, excludeEventId] as const,
    mine: ['events', 'mine'] as const,
  },
  vehicles: {
    all: ['vehicles'] as const,
  },
  audit: {
    all: (params?: Record<string, string>) => ['audit', params] as const,
  },
} as const;
